import React from 'react'
import { KeyDownEvent } from '../../utils/eventKey'
import { eventKeyConstants } from '../../utils/eventKey'
export default class DropdownComp extends React.Component {
  constructor(props) {
    super(props)
    let _defaultValue = this.getDefaultValue()
    let selectedValue = '',
      selectedText = '',
      selectedItem = {}
    if (_defaultValue) {
      selectedValue = _defaultValue.value
      selectedText = _defaultValue.name
      selectedItem = _defaultValue
    }
    this.state = {
      selectedValue: selectedValue,
      selectedText: selectedText,
      selectedItem,
      showOptions: false,
    }
    this.onChangeEvent = this.onChangeEvent.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.renderSelectedItem = this.renderSelectedItem.bind(this)
    this.clickDropdown = this.clickDropdown.bind(this)
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.checkarrowEvent = this.checkarrowEvent.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue != this.state.selectedValue) {
      let value = this.getOptionObject(
        nextProps.options,
        nextProps.defaultValue
      )
      if (value) {
        this.setState({
          selectedValue: value.value,
          selectedText: value.name,
          selectedItem: value,
        })
      }
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showOptions: false })
    }
  }

  getDefaultValue() {
    return this.getOptionObject(this.props.options, this.props.defaultValue)
  }

  getOptionObject(options = [], value) {
    return options.find((o) => o.value == value)
  }

  onChangeEvent (e, item) {
    e.preventDefault()
    const { onChange } = this.props;
    const childElems = [...e.target.parentElement.children]
    childElems.forEach((el) => {
      el.setAttribute('aria-selected', 'false');
    })
    e.target.setAttribute('aria-selected', 'true');
    this.setState(
      {
        selectedItem: item,
        selectedText: item.name,
        selectedValue: item.value,
        showOptions: false,
      },
      () => {
        onChange?.(e, item);
      }
    )
  }

  clickDropdown(e, updatedId) {
    if (!this.props.isNested) {
      e.preventDefault()
      if (this.props.isOldDis) {
        this.setState({ showOptions: false })
      } else {
        if (this.props.toPosDropDown) {
          $('.krRightPaneContent').parent().animate({ scrollTop: 70 })
        } else if (this.props.toShowCountAsDD) {
          $('.krRightPaneContent').parent().animate({ scrollTop: 100 })
        } else if (this.props.toShowProgressType) {
          $('.krRightPaneContent').parent().animate({
            scrollTop:
              $('.krRightPaneContent .metric-comp-wrapper').height() - 100,
          })
        } else if (this.props.toShowRecascadeType) {
          $('.kr-modal-content').animate({
            scrollTop: $('.kr-modal-content-inner').height() + 100,
          })
          // $(".contribute-kr-comp-wrapper").animate({ scrollTop: $(".contribute-kr-comp-wrapper").height() +200});
        } else if (this.props.toShowRollupProgressType) {
          $('.krRightPaneContent').parent().animate({
            scrollTop:
              $('.krRightPaneContent .rollup-kr-comp-wrapper').height() - 150,
          })
        }

        this.setState({ showOptions: !this.state.showOptions })
        if (!this.state.showOptions) {
          setTimeout(() => {
            const elem = document.getElementById('listItem0' + updatedId)
            if (elem) {
              elem.focus()
            }
          }, 1000)
        }
      }
    }
  }

  checkarrowEvent(e, item, index, enabled, updatedId) {
    e.stopPropagation()
    e.preventDefault()
    let options = this.props.options
    if (this.props.hideSelectedOption) {
      options = this.props.options.filter(
        (o) => o.value != this.state.selectedValue
      )
    }
    let currOption = options[index]
    let currIndex = index
    let maxLength = options.length
    if (e.key === eventKeyConstants.ENTER && enabled) {
      const focusEl = document.getElementById(updatedId)
      if (focusEl) focusEl.focus()
      this.onChangeEvent(e, item)
    }
    if (e.key === eventKeyConstants.TAB) {
      this.setState({ showOptions: !this.state.showOptions }, () => {
        let dropdownBtn = document.getElementById(updatedId)
        //let dropdownBtn = document.querySelector('.dropdowncomp-selected-item')
        dropdownBtn.focus()
      })
    }
    if (e.key === eventKeyConstants.ARROWUP) {
      if (currIndex == 0) {
        currOption = options[maxLength - 1]
        currIndex = maxLength - 1
      } else currOption = options[--currIndex]

      let prevItem = document.querySelector('#listItem' + currIndex + updatedId)
      prevItem.focus()
    }
    if (e.key === eventKeyConstants.ARROWDOWN) {
      if (currIndex == maxLength - 1) {
        currOption = options[0]
        currIndex = 0
      } else currOption = options[++currIndex]

      let nextItem = document.querySelector('#listItem' + currIndex + updatedId)
      nextItem.focus()
    }
    if (e.key === eventKeyConstants.ESCAPE) {
      this.setState({showOptions: false})

      let dropdown_btn = e.target.closest('.dropdowncomp-select').querySelector('.dropdowncomp-selected-item')
      setTimeout(() => dropdown_btn.focus())

      if (this.props.isWithinDialog) {
        $(e.target).closest('.ui-dialog-content').dialog('open') // To prevent the dialog from closing
      } 
    }
  }
  renderOption(item, index, updatedId) {
    let key =
      typeof item['value'] !== 'undefined' ? item['value'].toString() : index

    const enabled = item.enabled || item.enabled === undefined

    return (
      <div
        key={key}
        id={'listItem' + index + updatedId}
        role="option"
        aria-selected={this.state.selectedItem && this.state.selectedItem.name === item.name ? 'true' : 'false'}
        tabIndex={0}
        className={
          'dropdowncomp-option ' +
          this.props.optionClass +
          (!enabled ? ' disabled' : '')
        }
        data-testid="dropdowncomp-option"
        onClick={(e) => (enabled ? this.onChangeEvent(e, item) : {})}
        onKeyDown={(e) =>
          this.checkarrowEvent(e, item, index, enabled, updatedId)
        }
      >
        {this.props.optionRender ? this.props.optionRender(item) : item.name}
      </div>
    )
  }

  renderSelectedItem() {
    let { selectedText, selectedItem } = this.state
    if (this.props.renderSelectedItem) {
      return this.props.renderSelectedItem(selectedItem)
    } else {
      return selectedText
    }
  }

  render() {
    let options = this.props.options
    if (this.props.hideSelectedOption) {
      options = this.props.options.filter(
        (o) => o.value != this.state.selectedValue
      )
    }
    let showDropDownIcon =
      this.props.isOldDis || this.props.isNested ? true : false

    let style = {width:'fit-content'}
    if (this.props.style) {
      let marginDropdown = '-44px -530px'
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') == -1) {
          marginDropdown = '-44px  -570px'
        }
      }
      style = {
        width:'fit-content',
        height: '21px',
        padding: '8px',
        margin: marginDropdown,
        backgroundColor: showDropDownIcon ? '#FFFFFF' : '#f2f2f2',
      }
    }
    const updatedId = this.props.appendId
      ? 'dropdowncomp-btn-' + this.props.appendId
      : 'dropdowncomp-btn'
    return (
      <div
        ref={this.setWrapperRef}
        className={'dropdowncomp-wrapper ' + this.props.wrapperClass}
        id={this.props.jiraLabel ? "jiraDropdown" : ""}
      >
        {this.props.labelText ? (
          <div className="dropdowncomp-label">{this.props.labelText}</div>
        ) : (
          ''
        )}
        {this.renderSelectedItem() ? (
        <div
          className={`dropdowncomp-select ${this.props.selectClass}`}
          style={style}
        >
          <div
            className="dropdowncomp-selected-item"
            id={updatedId}
            onClick={(e) => this.clickDropdown(e, updatedId)}
            onKeyDown={(e) =>
              KeyDownEvent(e, () => this.clickDropdown(e, updatedId))
            }
            role="button"
            tabIndex="0"
            aria-haspopup="listbox"
            aria-expanded={this.state.showOptions ? 'true' : 'false'}
            style={{
              cursor: showDropDownIcon ? 'default' : 'pointer',
              marginTop: this.props.style ? '-3px' : '',
              display: 'flex',
              alignItems: 'center',
            }}
            aria-describedby={this.props.labelId}
          >
            <div
              className="dropdowncomp-selected-text"
              data-testid="dropdowncomp-selected-text"
              style={
                this.props.selectedTextStyle ? this.props.selectedTextStyle : {flexGrow : 1, whiteSpace: 'nowrap'}
              }
            >
              {this.renderSelectedItem()}
            </div>
            <div
              className="icon icon-dropdown-14px-2"
              style={{ display: showDropDownIcon ? 'none' : 'inline-block', marginLeft: 5 }}
            ></div>
          </div>
          <div
            role="listbox"
            //tabIndex={0}
            className={'dropdowncomp-options ' + this.props.optionsClass + (wbConfig.userLocale == 'nl' ? ' dropdowncomp-options-locale-nl' : '')}
            style={{
              display: this.state.showOptions ? 'block' : 'none',
              top: '38px',
              minWidth:
                wbConfig.default_org_locale == 'locale_2' ? '150px' : '',
            }}
            // onKeyDown={(e) => {
            //   if (e.keyCode === 9) {
            //     $('.dropdowncomp-option')[0].focus()
            //   }
            // }}
            aria-activedescendant={this.state.selectedItem}
          >
            {options.map((option, index) =>
              this.renderOption(option, index, updatedId)
            )}
          </div>
        </div>
         ) : ( '' )} 
      </div>
    )
  }
}

DropdownComp.defaultProps = {
  wrapperClass: '',
  labelText: '',
  defaultValue: '',
  optionsClass: '',
  options: [],
  optionClass: '',
  onChange: null,
  hideSelectedOption: false,
  optionRender: null,
  renderSelectedItem: null,
  appendId: null,
  jiraLabel: false,
  isWithinDialog: false,
  labelId: null
}
